import React, { useCallback, useContext, useEffect } from 'react'
import { ActionButtonsStyles } from './Style'
import { Button } from 'components/Form'
import { LightButton } from 'styles/GlobalStyle'
import { useDispatch } from 'react-redux'
import { change, initialize, isValid, reset, submit } from 'redux-form'
import { CreateAssessmentDefContext } from './CreateAssessmentDefContext'
import { useSelector } from 'react-redux'
import { CreateAssessmentDefRM } from 'models/RM'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { assesmentDefStatuses, categories } from 'keys'
import { saveAssessmentDefFetch, updateAssessmentDefFetch } from 'store/middlewares/assessment.crud'
import { toast } from 'react-toastify'
import { toastConfig } from 'config'
import { useNavigate, useParams } from 'react-router-dom'
import { app } from 'router/routes'
import { queryClient as qc } from 'keys'

const ActionButtons = () => {
    const isFormValid = useSelector(state => isValid('createAssessmentDef')(state));
    const formValues = useSelector(state => state.form.createAssessmentDef?.values)
    const { textUpdated, setTextUpdated, question, categoryViews, categoryItem, currentItemIndex } = useContext(CreateAssessmentDefContext)
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const queryClient = useQueryClient()
    const params = useParams()
    const assessmentDefID = params.assessmentDefID

    const goEditAssessmentPage = useCallback((id) => {
        navigate(`${app.assessmentLibrary}/${id}`)
    }, [])

    const { mutateAsync: saveAssessmentDef, isPending } = useMutation({
        mutationFn: async (data) => {
            if (assessmentDefID)
                await updateAssessmentDefFetch(data)
            else {
                const res = await saveAssessmentDefFetch(data)
                goEditAssessmentPage(res.data.id)
            }
        },
        onSuccess: () => {
            setTextUpdated(false)
            if (assessmentDefID)
                toast("המבדק התעדכן בהצלחה", toastConfig)
            else toast("המבדק נוצר בהצלחה", toastConfig)
            queryClient.invalidateQueries([qc.assessmentDefs])
        },
        onError: ({ response }) => {
            const { data } = response || {}
            if (data?.code?.[0] == "DUPLICATE_ASSESSMENT_NAME")
                toast.error("שם  מבדק קיים במערכת", toastConfig)
            else toast.error("שגיאה בשמירה ", toastConfig)
        }
    })

    const cleanData = useCallback(() => {
        dispatch(reset("createAssessmentDef"))
        dispatch(initialize('createAssessmentDef', {}));
        dispatch(change('createAssessmentDef', `questions[${currentItemIndex}]`, question))
    }, [])

    const validations = useCallback((status) => {
        if (!isFormValid) {
            toast.error('מלא את כל שדות החובה', toastConfig)
            dispatch(submit('createAssessmentDef')) // Trigger validation for the current step
            return false
        }

        else if (!categoryViews[categoryItem?.name]) {
            toast.error("קטגוריה זו עדיין נעולה ליצירת מבדקים", toastConfig)
            return false
        }

        else if (status == assesmentDefStatuses.ACTIVE) {
            let hasCorrectAllAnswerFlag = true

            formValues?.questions?.forEach(question => {
                let hasCorrectAnswerFlag = false
                question.answer_defs.forEach(answer => {
                    if (answer.is_correct)
                        hasCorrectAnswerFlag = true
                });
                if (!hasCorrectAnswerFlag)
                    hasCorrectAllAnswerFlag = false
            });
            if (!hasCorrectAllAnswerFlag) {
                toast.error("ישנה שאלה שלא הוגדר עבורה תשובה נכונה", toastConfig)
                return false
            }
        }
        return true
    }, [isFormValid, formValues, categoryItem])

    const saveAsDraft = useCallback(() => {
        let assessmentDef = { status: assesmentDefStatuses.DRAFT, text_updated: true }
        if (validations(assessmentDef.status)) {
            assessmentDef = new CreateAssessmentDefRM({ ...formValues, ...assessmentDef })
            saveAssessmentDef(assessmentDef)
        }
    }, [isFormValid, formValues, textUpdated])

    const save = useCallback(async () => {
        let assessmentDef = { status: assesmentDefStatuses.ACTIVE, text_updated: true }
        if (validations(assessmentDef.status)) {
            assessmentDef = new CreateAssessmentDefRM({ ...formValues, ...assessmentDef })
            await saveAssessmentDef(assessmentDef)
            navigate(app.assessmentLibrary)
        }
    }, [isFormValid, formValues, textUpdated])

    return (
        <ActionButtonsStyles>
            <LightButton
                variant="solid"
                label="ניקוי"
                action={cleanData}
                size="small"
            />
            <Button
                label="שמירה כטיוטה"
                action={saveAsDraft}
                size="small"
                color="dark"
                loading={isPending}
                disabled={isPending}
            />
            <Button
                loading={isPending}
                disabled={isPending}
                label="שמירה"
                action={save}
                size="small"
                color="dark"
            />
        </ActionButtonsStyles>
    )
}

export default ActionButtons